class CountryCasaHome {
  constructor() {
    this.floatingText = document.querySelector('[data-cc-floating-text]');
    this.footer =
      document.querySelector("[id$='__footer_utilities']") ||
      document.querySelector('.shopify-section-group-footer-group:last-of-type');
    this.contact = document.querySelector('.cc-contact');
    this.quickActions = document.querySelector('.cc-quick-actions');
    this.updateFloatingText = this.updateFloatingText.bind(this);
  }

  init() {
    this.initReveals();

    if (this.floatingText && this.footer) {
      window.addEventListener('scroll', this.updateFloatingText, { passive: true });
      window.addEventListener('resize', this.updateFloatingText);
      this.updateFloatingText();
    }
  }

  initReveals() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      return;
    }

    const revealElements = document.querySelectorAll(
      "main[data-template='index'] .cc-section, main[data-template='index'] .section-resource-list"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    revealElements.forEach((element) => {
      element.classList.add('cc-reveal');
      observer.observe(element);
    });
  }

  updateFloatingText() {
    const footerTop = this.footer.getBoundingClientRect().top;
    const contactRect = this.contact?.getBoundingClientRect();
    const quickActionsRect = this.quickActions?.getBoundingClientRect();
    const contactAtButton = contactRect
      ? contactRect.top < window.innerHeight && contactRect.bottom > window.innerHeight - 104
      : false;
    const quickActionsVisible = quickActionsRect
      ? quickActionsRect.top < window.innerHeight && quickActionsRect.bottom > window.innerHeight - 104
      : false;
    const shouldHide = footerTop < window.innerHeight - 24 || contactAtButton || quickActionsVisible;
    this.floatingText.dataset.hidden = String(shouldHide);
  }
}

const countryCasaHome = new CountryCasaHome();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => countryCasaHome.init(), { once: true });
} else {
  countryCasaHome.init();
}
